// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLeftSidebar {
  display: flex;
  flex-direction: column;
  min-width: 244px;
  width: 244px;
  background-color: #f7f8f9;
  box-shadow: 0 2px 2px 0 #bbbcbd;
}

  .AdminLeftSidebar__group-title {
      font-weight: 500;
      width: 100%;
      height: 49px;
      padding: 18px;
    }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/AdminLeftSideBar/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;AAUjC;;EAPI;MACE,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,aAAa;IACf","sourcesContent":[".AdminLeftSidebar {\n  display: flex;\n  flex-direction: column;\n  min-width: 244px;\n  width: 244px;\n  background-color: #f7f8f9;\n  box-shadow: 0 2px 2px 0 #bbbcbd;\n\n  &__group {\n    &-title {\n      font-weight: 500;\n      width: 100%;\n      height: 49px;\n      padding: 18px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
